import { render, staticRenderFns } from "./TemplateEditForm.vue?vue&type=template&id=2498c9d0&scoped=true&"
import script from "./TemplateEditForm.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateEditForm.vue?vue&type=style&index=0&id=2498c9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498c9d0",
  null
  
)

export default component.exports